<template>
  <div
    class="license-code-component-container"
    :class="{mastery}"
  >
    <label class="title">
      Activation Code (Optional)
      <button
        v-if="showExpanderButton"
        class="button-reset"
        @click="toggleShowActivationInput"
      >
        <icon
          :name="showActivationInput ? 'chevron-up' : 'chevron-down'"
          class="chevron-icon"
        />
      </button>
    </label>
    <div
      class="activation-code-input"
      :class="{ hide: !showActivationInput }"
    >
      <input
        v-for="(block, index) in blocks"
        :key="index"
        :ref="`code-${activator.id}-${index}`"
        v-model="codes[index]"
        :aria-label="`Activation code input ${index + 1}`"
        type="text"
        :maxlength="characters"
        :placeholder="placeholder"
        :style="{ width: cssWidth}"
        @input="onInput(index)"
        @keypress="restrictInput($event)"
      >
    </div>
  </div>
</template>

<script>
import Icon from '@components/singletons/icon';

export default {
  components: { Icon },
  props: {
    activator: {
      type: Object,
      default: () => ({}),
    },
    mastery: {
      type: Boolean,
    },
    showExpanderButton: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      codes: [],
      showActivationInput: !this.showExpanderButton,
    };
  },
  computed: {
    blocks() {
      return this.activator.config.blocks;
    },
    characters() {
      return this.activator.config.length;
    },
    cssWidth() {
      return `${this.characters}ch`;
    },
    placeholder() {
      return '0'.repeat(this.characters);
    },
    valid() {
      return this.codes.some(block => block.length > 0);
    },
  },
  created() {
    this.codes = Array(this.blocks).fill('');
  },
  methods: {
    onInput(index) {
      this.change();
      this.triggerTab(index);
    },
    change() {
      let params = {
        id: this.activator.id,
      };

      if (this.valid) {
        params.data = {
          code: this.codes.join('-'),
        };
      }

      this.$eventBus.$emit('activation-code-change', params);
    },
    restrictInput(e) {
      if (!/[a-z0-9]/i.test(e.key)) {
        e.preventDefault();
      }
    },
    toggleShowActivationInput() {
      this.showActivationInput = !this.showActivationInput;
    },
    triggerTab(index) {
      const isFull = this.codes[index].length >= this.characters;
      const notLastBlock = index < (this.blocks - 1);
      if (isFull && notLastBlock) {
        this.$refs[`code-${this.activator.id}-${index + 1}`][0].focus();
      }
    },
  },
};
</script>

<style lang='scss' scoped>
.license-code-component-container {
  margin-top: rem-calc(4);

  input {
    border: 1px solid #dfe3e9;
    border-radius: 4px;
    color: #7f8fa4;
    font-family: monospace !important;;
    font-size: rem-calc(18);
    margin: rem-calc(4) rem-calc(4) rem-calc(12) rem-calc(4);
    padding: rem-calc(8);
    text-transform: uppercase;
    // Fallback width if browser doesn't support ch unit
    width: rem-calc(54);

    @include focus-not-visible {
      outline: none !important;
    }

    &:first-of-type {
      margin-left: 0;
    }
  }

  &.mastery {
    text-align: left;
    input {
      border: 1px solid #001c74;
      border-radius: 1px;

      &::placeholder {
        color: var(--text-placeholder);
      }
    }

    label {
      display: block;
    }
  }
}
.chevron-icon {
  margin-left: rem-calc(4);
}

.activation-code-input {
  overflow: hidden;
  max-height: 100px;
  transition: max-height 0.3s ease-in-out;
}

.activation-code-input.hide {
  max-height: 0;
}
</style>
